var map = {
	"./App": 53918,
	"./App.vue": 53918,
	"./assets/css/anim.scss": 98570,
	"./assets/css/common.scss": 90807,
	"./assets/css/global.scss": 23059,
	"./assets/css/reset.scss": 12841,
	"./assets/css/setting.scss": 93373,
	"./assets/css/utils.scss": 55955,
	"./assets/fonts/POPPINS-MEDIUM.OTF": 75936,
	"./assets/fonts/POPPINS-REGULAR.OTF": 49059,
	"./assets/fonts/POPPINS-SEMIBOLD.OTF": 40336,
	"./assets/fonts/font.css": 39399,
	"./assets/icons": 17258,
	"./assets/icons/": 17258,
	"./assets/icons/index": 17258,
	"./assets/icons/index.js": 17258,
	"./assets/icons/svg/change.svg": 43151,
	"./assets/icons/svg/close.svg": 63148,
	"./assets/icons/svg/copy.svg": 3525,
	"./assets/icons/svg/disconnect.svg": 10710,
	"./assets/icons/svg/explorer.svg": 78913,
	"./assets/icons/svg/home.svg": 3945,
	"./assets/icons/svg/icon-arrow.svg": 51089,
	"./assets/icons/svg/icon-conversion.svg": 49547,
	"./assets/icons/svg/icon-ok.svg": 35686,
	"./assets/icons/svg/icon-search.svg": 84814,
	"./assets/icons/svg/icon-share.svg": 71820,
	"./assets/icons/svg/icon-time.svg": 94375,
	"./assets/icons/svg/icon-up.svg": 33442,
	"./assets/icons/svg/img-empty.svg": 23002,
	"./assets/icons/svg/loading.svg": 66859,
	"./assets/icons/svg/more.svg": 54911,
	"./assets/icons/svg/mytokens.svg": 47274,
	"./assets/icons/svg/ranking.svg": 12782,
	"./assets/icons/svg/referral.svg": 5948,
	"./assets/icons/svg/rewards.svg": 49769,
	"./assets/icons/svg/setting.svg": 22540,
	"./assets/icons/svg/telegram.svg": 91068,
	"./assets/icons/svg/timeH5svg.svg": 36489,
	"./assets/icons/svg/twitter.svg": 43927,
	"./assets/icons/svg/txns.svg": 92634,
	"./assets/icons/svg/zoom.svg": 97867,
	"./assets/icons/svg/zoomOut.svg": 49220,
	"./assets/images/icons/base-logo-in-blue.svg": 27543,
	"./assets/images/icons/bnb-bnb-logo.svg": 68149,
	"./assets/images/icons/ethereum-eth-logo.svg": 35904,
	"./assets/images/ui/btn-add-bg.jpg": 1425,
	"./assets/images/ui/btn-add-icon.png": 76268,
	"./assets/images/ui/howWork-1.jpg": 75968,
	"./assets/images/ui/howWork.png": 95448,
	"./assets/images/ui/index-head-bg-h5.jpg": 66392,
	"./assets/images/ui/index-head-bg.jpg": 80377,
	"./assets/images/ui/logo.png": 52989,
	"./assets/images/ui/marspump.png": 60346,
	"./assets/images/ui/referral-total-1.png": 5058,
	"./assets/images/ui/referral-total-2.png": 36460,
	"./assets/images/ui/referral-total-bg1.jpg": 54357,
	"./assets/images/ui/referral-total-bg2.jpg": 41258,
	"./assets/images/ui/reward/mining-q-1.jpg": 10472,
	"./assets/images/ui/reward/mining-q-1.png": 56768,
	"./assets/images/ui/reward/mining-q-2.png": 14839,
	"./assets/images/ui/reward/mining-q-3.png": 29656,
	"./assets/images/ui/reward/mining-q-4.png": 10907,
	"./assets/images/ui/reward/mining-q-5.png": 77833,
	"./assets/images/ui/tab-icon-1.png": 21752,
	"./assets/images/ui/tab-icon-2.png": 95959,
	"./assets/images/ui/tab-icon-3.png": 31446,
	"./assets/images/ui/tab-icon-4.png": 60315,
	"./assets/js/assetsManifest": 55715,
	"./assets/js/assetsManifest.json": 55715,
	"./assets/js/eventBus": 1093,
	"./assets/js/eventBus.js": 1093,
	"./assets/js/noZoom": 62654,
	"./assets/js/noZoom.js": 62654,
	"./assets/js/pop": 42487,
	"./assets/js/pop.js": 42487,
	"./assets/js/rem": 79633,
	"./assets/js/rem.js": 79633,
	"./assets/js/requestApiCache": 91270,
	"./assets/js/requestApiCache.js": 91270,
	"./assets/js/web3Chain": 94257,
	"./assets/js/web3Chain.js": 94257,
	"./assets/js/web3Fnc": 3235,
	"./assets/js/web3Fnc.js": 3235,
	"./components/layout": 51181,
	"./components/layout.vue": 51181,
	"./components/mEmpty": 34929,
	"./components/mEmpty.vue": 34929,
	"./components/mImgCutter": 64307,
	"./components/mImgCutter.vue": 64307,
	"./components/mImgEmpty": 42176,
	"./components/mImgEmpty.vue": 42176,
	"./components/mLaunch": 45073,
	"./components/mLaunch.vue": 45073,
	"./components/mPage": 44164,
	"./components/mPage.vue": 44164,
	"./components/mTransaction": 80261,
	"./components/mTransaction.vue": 80261,
	"./components/pFooter": 80881,
	"./components/pFooter.vue": 80881,
	"./components/pHead": 70507,
	"./components/pHead.vue": 70507,
	"./components/pHeadBtns": 41723,
	"./components/pHeadBtns.vue": 41723,
	"./components/pIndexHead": 11102,
	"./components/pIndexHead.vue": 11102,
	"./components/pIndexListItem": 27181,
	"./components/pIndexListItem.vue": 27181,
	"./components/pMenu": 19873,
	"./components/pMenu.vue": 19873,
	"./components/pProgress": 37906,
	"./components/pProgress.vue": 37906,
	"./components/pSearch": 70967,
	"./components/pSearch.vue": 70967,
	"./components/pTab": 98695,
	"./components/pTab.vue": 98695,
	"./components/pTokenFrom": 42311,
	"./components/pTokenFrom.vue": 42311,
	"./components/pWalletMenu": 13009,
	"./components/pWalletMenu.vue": 13009,
	"./components/popHowWorks": 22777,
	"./components/popHowWorks.vue": 22777,
	"./components/popPrompt": 46132,
	"./components/popPrompt.vue": 46132,
	"./components/popSlippage": 96013,
	"./components/popSlippage.vue": 96013,
	"./components/popStake": 31058,
	"./components/popStake.vue": 31058,
	"./components/popTerms": 36142,
	"./components/popTerms.vue": 36142,
	"./components/popUnStake": 36038,
	"./components/popUnStake.vue": 36038,
	"./components/svgIcon": 48096,
	"./components/svgIcon.vue": 48096,
	"./components/toolTip": 67759,
	"./components/toolTip.vue": 67759,
	"./directive": 90973,
	"./directive/": 90973,
	"./directive/direct/v-anchor": 52828,
	"./directive/direct/v-anchor.js": 52828,
	"./directive/direct/v-copy": 44404,
	"./directive/direct/v-copy.js": 44404,
	"./directive/direct/v-debounce": 64459,
	"./directive/direct/v-debounce.js": 64459,
	"./directive/direct/v-draggable": 52971,
	"./directive/direct/v-draggable.js": 52971,
	"./directive/direct/v-scroll": 57660,
	"./directive/direct/v-scroll.js": 57660,
	"./directive/direct/v-shuibowen": 73131,
	"./directive/direct/v-shuibowen.js": 73131,
	"./directive/index": 90973,
	"./directive/index.js": 90973,
	"./http": 11063,
	"./http/": 11063,
	"./http/index": 11063,
	"./http/index.js": 11063,
	"./i18n": 86926,
	"./i18n/": 86926,
	"./i18n/i18nOption": 17292,
	"./i18n/i18nOption.json": 17292,
	"./i18n/index": 86926,
	"./i18n/index.js": 86926,
	"./i18n/json/Chs": 15077,
	"./i18n/json/Chs.json": 15077,
	"./i18n/json/En": 74030,
	"./i18n/json/En.json": 74030,
	"./main": 43217,
	"./main.js": 43217,
	"./mixins/anim": 82568,
	"./mixins/anim.js": 82568,
	"./router": 15092,
	"./router/": 15092,
	"./router/index": 15092,
	"./router/index.js": 15092,
	"./store": 68854,
	"./store/": 68854,
	"./store/index": 68854,
	"./store/index.js": 68854,
	"./store/modules/user": 69220,
	"./store/modules/user.js": 69220,
	"./store/modules/wallet": 9944,
	"./store/modules/wallet copy": 52489,
	"./store/modules/wallet copy.js": 52489,
	"./store/modules/wallet.js": 9944,
	"./utils": 1474,
	"./utils/": 1474,
	"./utils/errcode": 48956,
	"./utils/errcode.js": 48956,
	"./utils/formatter": 83291,
	"./utils/formatter.js": 83291,
	"./utils/index": 1474,
	"./utils/index.js": 1474,
	"./utils/v3price": 10144,
	"./utils/v3price.js": 10144,
	"./view": 46048,
	"./view/": 46048,
	"./view/index": 46048,
	"./view/index.vue": 46048,
	"./view/launch": 84236,
	"./view/launch.vue": 84236,
	"./view/myToken": 16004,
	"./view/myToken.vue": 16004,
	"./view/ranking": 19306,
	"./view/ranking.vue": 19306,
	"./view/referral": 41227,
	"./view/referral.vue": 41227,
	"./view/reward": 37740,
	"./view/reward.vue": 37740,
	"./view/token/_id": 64396,
	"./view/token/_id.vue": 64396,
	"./view/twitter/callback": 37845,
	"./view/twitter/callback.vue": 37845,
	"./web3Wallet": 79305,
	"./web3Wallet/": 79305,
	"./web3Wallet/config/config": 7935,
	"./web3Wallet/config/config.json": 7935,
	"./web3Wallet/config/config_v2": 80011,
	"./web3Wallet/config/config_v2.json": 80011,
	"./web3Wallet/config/config_v3_test": 70772,
	"./web3Wallet/config/config_v3_test.json": 70772,
	"./web3Wallet/config_for_test/config": 94175,
	"./web3Wallet/config_for_test/config.json": 94175,
	"./web3Wallet/contracts/bondingcurve": 71562,
	"./web3Wallet/contracts/bondingcurve.json": 71562,
	"./web3Wallet/contracts/lplocker": 9334,
	"./web3Wallet/contracts/lplocker.json": 9334,
	"./web3Wallet/contracts/marspump": 93924,
	"./web3Wallet/contracts/marspump.json": 93924,
	"./web3Wallet/contracts/marspump_v2": 30892,
	"./web3Wallet/contracts/marspump_v2.json": 30892,
	"./web3Wallet/contracts/powerpool": 75663,
	"./web3Wallet/contracts/powerpool.json": 75663,
	"./web3Wallet/contracts/token": 74528,
	"./web3Wallet/contracts/token.json": 74528,
	"./web3Wallet/contracts/tokenpool": 90915,
	"./web3Wallet/contracts/tokenpool.json": 90915,
	"./web3Wallet/contracts/v3pool": 28475,
	"./web3Wallet/contracts/v3pool.json": 28475,
	"./web3Wallet/contracts_for_test/bondingcurve": 22843,
	"./web3Wallet/contracts_for_test/bondingcurve.json": 22843,
	"./web3Wallet/contracts_for_test/lplocker": 55325,
	"./web3Wallet/contracts_for_test/lplocker.json": 55325,
	"./web3Wallet/contracts_for_test/marspump": 21593,
	"./web3Wallet/contracts_for_test/marspump.json": 21593,
	"./web3Wallet/contracts_for_test/marspump_v2": 79389,
	"./web3Wallet/contracts_for_test/marspump_v2.json": 79389,
	"./web3Wallet/contracts_for_test/powerpool": 24872,
	"./web3Wallet/contracts_for_test/powerpool.json": 24872,
	"./web3Wallet/contracts_for_test/token": 77543,
	"./web3Wallet/contracts_for_test/token.json": 77543,
	"./web3Wallet/contracts_for_test/tokenpool": 40599,
	"./web3Wallet/contracts_for_test/tokenpool.json": 40599,
	"./web3Wallet/contracts_for_test/v3pool": 56537,
	"./web3Wallet/contracts_for_test/v3pool.json": 56537,
	"./web3Wallet/index": 79305,
	"./web3Wallet/index.js": 79305,
	"./web3Wallet/networkIcons": 57455,
	"./web3Wallet/networkIcons.js": 57455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;